/**
 * Language constants needed at module-init time for i18n. These read window.__SCHA_BOOT__
 * (the 5-field inline literal, ADR 0003). They MUST stay module-scope: utils/i18n.ts initializes
 * i18next (and writes window.t for Kameleoon) at module load using these values.
 *
 * All other former appConstants have migrated off window.SCHA (ADR 0003):
 *  - bootstrap-scoped config (currency, formatting, batching, site flags, ...) →
 *    useAppConfig() in features/pages/components, getRuntimeConfig() in src/common utils &
 *    src/domains services;
 *  - session-scoped (delivery offset, sunday delivery, ...) →
 *    useSession() in components, getRuntimeConfig() in pure utils/services.
 *
 * AVAILABLE_LANGUAGES is consumed lazily by the language switcher via useAppConfig().
 */
export const DEFAULT_LANGUAGE = window.__SCHA_BOOT__?.fallbackLanguage || "en";
export const CURRENT_LANGUAGE = window.__SCHA_BOOT__?.language || DEFAULT_LANGUAGE;
